import styled from '@emotion/styled';
import { Breakpoints } from '@settings';
import React from 'react';

type Props = {
  size?: 'sm' | 'md';
  className?: string;
  bgColor?: string;
  textColor?: string;
  children: React.ReactNode;
};

const StyledBadge = styled.div<Pick<Props, 'bgColor' | 'textColor' | 'size'>>`
  background-color: ${(props) => props.bgColor};
  color: ${(props) => props.textColor};
  font-size: ${(props) => (props.size === 'sm' ? '12px' : '14px')};
  padding: ${(props) => (props.size === 'sm' ? '4px 8px' : '8px 12px')};
  font-weight: bold;
  text-align: center;
  border-radius: 3rem;

  @media (max-width: ${Breakpoints.MD}px) {
    font-size: ${(props) => (props.size === 'sm' ? '10px' : '12px')};
  }
`;

const Badge = ({
  size = 'sm',
  className = '',
  bgColor = 'var(--onsale-color)',
  textColor = '#fff',
  children,
}: Props) => {
  return (
    <StyledBadge bgColor={bgColor} textColor={textColor} size={size} className={className}>
      {children}
    </StyledBadge>
  );
};

export default Badge;
